<template></template>

<script>
import { mapState } from 'vuex';

export default {
    computed: mapState(['contact', 'emailInput']),
    data() {
        return {
            currentEmail: null,
            currentId: null,
        };
    },
    methods: {
        setErrorContext() {
            let email = this.contact && this.contact.email ? this.contact.email : this.emailInput;

            let id = this.contact && this.contact.ips_id ? this.contact.ips_id : null;

            const emailRegularExpression = /\S+@\S+\.\S+/;

            if (!email || !emailRegularExpression.test(email)) {
                email = null;
            }

            if (this.currentEmail !== email || this.currentId !== id) {
                this.currentEmail = email;
                this.currentId = id;

                logger.setUser({ id, email });
            }
        },
    },
    watch: {
        contact: function () {
            this.setErrorContext();
        },
        emailInput: function () {
            this.setErrorContext();
        },
    },
    mounted() {
        this.setErrorContext();
    },
};
</script>
